import { render, staticRenderFns } from "./MangeDownloadForms.vue?vue&type=template&id=7a5aa9aa&scoped=true&"
import script from "./MangeDownloadForms.vue?vue&type=script&lang=js&"
export * from "./MangeDownloadForms.vue?vue&type=script&lang=js&"
import style0 from "./MangeDownloadForms.vue?vue&type=style&index=0&id=7a5aa9aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5aa9aa",
  null
  
)

export default component.exports